import React, { useState } from 'react';
import { Redirect } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import { useTranslation } from 'react-i18next';
import { motion } from 'framer-motion';

import { ACCOUNTS_ACTIONS, updateAccount } from 'store/accounts';
import AuthService from 'lib/auth/AuthService';
import useEvent from 'v1/helpers/hooks/useEvent';

import OnboardingViewBase from '../OnboardingViewBase';
import CreateProfilePanel from './CreateProfilePanel';
import { Heading, Text } from 'shared';
import { myToastService } from 'v5/services/front/ToastService/ToastService.connected';

const CreateProfile = ({ location }) => {
  const { t } = useTranslation('v1-features');
  const dispatch = useDispatch();
  const [updateComplete, setUpdateComplete] = useState(false);
  const [isExiting, setIsExiting] = useState(false);

  useEvent([ACCOUNTS_ACTIONS.updateAccount], {
    onSuccess: () => {
      setIsExiting(true);
    }
  });

  const onSubmit = async data => {
    try {
      const token = AuthService.token();
      const id = token.account.id;
      await dispatch(updateAccount({ id, data }));
    } catch (error) {
      myToastService.open({ type: 'error', message: error.message });
    }
  };

  if (updateComplete) {
    const teamSchema = location.state.teamSchema;
    return (
      <Redirect
        to={{
          pathname: `/app/${teamSchema}/onboarding/completed-registration`,
          state: { teamSchema }
        }}
      />
    );
  }

  const handleAnimationComplete = () => {
    if (isExiting) {
      setUpdateComplete(true);
    }
  };

  return (
    <OnboardingViewBase>
      <motion.div
        initial={{ opacity: 0, y: 10 }}
        animate={{ opacity: isExiting ? 0 : 1, y: isExiting ? -10 : 0 }}
        transition={{ duration: 0.5, ease: 'easeInOut' }}
        onAnimationComplete={handleAnimationComplete}
      >
        <Heading type="h2" stack="xs">
          {t('CreateProfile.header')}
        </Heading>
        <Text size="m" color="black" stack="l">
          {t('CreateProfile.subheader')}
        </Text>
        <CreateProfilePanel onSubmit={onSubmit} />
      </motion.div>
    </OnboardingViewBase>
  );
};

export default CreateProfile;
